import { useCallback, useState } from "react";

import { Dealer } from "../../../../dtos/dealer";
import { AjaxResult } from "../../../../enums/ajaxResult";
import { useApi } from "../../../useApi";

export function useDealerLoad(dealerId: number | undefined) {
    const [dealer, setDealer] = useState<Dealer>();
    const [loading, setLoading] = useState(false);
    const { dealerApi } = useApi();

    const loadDealer = useCallback(() => {
        if (!dealerId) {
            return;
        }
        setLoading(true);
        dealerApi.getById(dealerId).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setDealer(r.data);
            }
            setLoading(false);
        });
    }, [dealerApi, dealerId]);

    return {
        loadDealer,
        dealer,
        loading,
    };
}